module.exports = __webpack_public_path__ + "static/media/weaknesses.9556c552.png";